import { isString } from 'shared/lib/type-guards';
import {
  useGetInitialFiltersFromUrl,
  useGetSortFromUrl,
  useGetPaginationFromUrl,
  useGetFiltersUrl,
} from 'shared/lib/hooks';
import type { Option } from 'shared/ui/Select';

import type { DBAs } from '../model';
import { ManagerContractorsFilters, ManagerContractorsSort, PromoStatusModel, PromoTypes } from '../model';

export const isPromoType = (value: unknown): value is keyof typeof PromoTypes => {
  return isString(value) && value in PromoTypes;
};

export const isPromoStatus = (value: unknown): value is PromoStatusModel => {
  return isString(value) && value in PromoStatusModel;
};

export const useGetManagerContractorFilter = () => {
  const filters = useGetInitialFiltersFromUrl({
    filterKeys: ManagerContractorsFilters,
  });
  const sorting = useGetSortFromUrl(ManagerContractorsSort);
  const pagination = useGetPaginationFromUrl();
  const { filtersFromURL } = useGetFiltersUrl({
    urlFilters: [filters, pagination, sorting],
  });

  return filtersFromURL;
};

export const getDbaOptions = (companyName = '', dbas: DBAs = []) => {
  const items: Option[] = [{ text: companyName, id: '0' }];

  dbas.forEach((item) => {
    const elementToAdd = { text: item.name, id: item.id.toString() };

    items.push(elementToAdd);
  });

  return items;
};
